<h2 class="text-decoration-underline">Translation System</h2>
<router-outlet></router-outlet>


